<div class="table-container m-t-12">
  @if ((getLabourRatesApiCallStatus === 'COMPLETED_SUCCESFULLY' && data.length > 0) || getLabourRatesApiCallStatus === 'IN_PROGRESS') {
    <mc-table
      data-cy="labour-rates-list"
      [data]="data.length > 0 ? data : mockDataForLoadingAnimation"
      fit="small"
      [columns]="columns"
      nowrap="true"
      sortmanual
      sortdefaultdirection="descending"
      (sortchange)="onSortDirectionChange($event)"
      tabularFigures="true"
      headersticky
      height="100%">
      @for (row of data; track row; let i = $index) {
        @for (col of columns; track col) {
          @if (col.id !== 'isEmpty' && col.id !== 'actions') {
            <div slot="{{ row.id }}_{{ col.id }}">
              {{ getValue(row, col.id) }}
            </div>
          }
          @if (col.id === 'actions') {
            <div slot="{{ row.id }}_actions" class="action-icon">
              <mc-button
                [hidden]="!row.mreRateNumber"
                padding="compact"
                fit="small"
                hiddenlabel
                icon="arrow-anti-clockwise-clock"
                appearance="primary"
                variant="plain"
                slot="trigger"
                (click)="onAuditLogClicked(row)"
                (keydown.enter)="onAuditLogClicked(row)"
                (keydown.space)="$event.preventDefault(); onAuditLogClicked(row)"></mc-button>
            </div>
          }
        }
      }

      @for (row of mockDataForLoadingAnimation; track $index) {
        @for (item of columns; track $index) {
          <div slot="{{ row.id }}_{{ item.id }}">
            <app-loader></app-loader>
          </div>
        }
      }
    </mc-table>
  } @else {
    <div class="pure-g">
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-204 flex-container flex-center no-data">
        <span i18n>No Data Found</span>
      </div>
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-36 flex-container flex-center">
        <span i18n>To widen your search, change or remove filters.</span>
      </div>
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-36 flex-container flex-center">
        <mc-button
          i18n-label="Button"
          label="Clear all filters"
          variant="filled"
          appearance="primary"
          (click)="clearFilter()"
          (keydown.enter)="clearFilter()"
          (keydown.space)="$event.preventDefault(); clearFilter()"
          fit="small"></mc-button>
      </div>
    </div>
  }
</div>
@if (data.length > 0) {
  <div class="pure-g m-t-16 footer">
    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24">
      <mc-select
        style="width: 140px; display: block"
        [value]="pageLimit"
        optionswidth="100px"
        ngDefaultControl
        label="Per page"
        labelposition="left"
        fit="small"
        (optionselected)="onPageLimitChange($event)">
        @for (pageCount of [10, 20, 50, 100, 200]; track pageCount) {
          <mc-option [value]="pageCount">{{ pageCount }}</mc-option>
        }
      </mc-select>
    </div>
    <div class="pure-u-md-12-24 pure-u-lg-16-24 pure-u-xl-16-24 flex-container flex-center">
      <mc-pagination
        hiddenlabels
        [currentpage]="currentPage"
        [totalpages]="lastPage"
        visiblepages="7"
        (pagechange)="onPageChange($event)"
        fit="small">
      </mc-pagination>
    </div>
    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24 text-align-right">
      <span class="page-description" i18n>Showing {{ data.length }} of {{ totalItemCount }}</span>
    </div>
  </div>
}

<mc-modal backdropcloseactiondisabled heading="Audit Log" fit="small" dimension="large" [open]="openAuditLog" (closed)="onAuditLogClosed()">
  @if (openAuditLog) {
    <app-master-data-audit-log [transactionCode]="selectedMreRateNumber" [label]="'MRE Rate Number'" [auditLogFetcher]="auditLogFetcher">
    </app-master-data-audit-log>
  }
</mc-modal>
